import { Navigate, useLocation } from 'react-router-dom';
import { useAppSelector } from '../store/hooks';
import { useCustomerAuthSlice } from '../store/slices/customerAuth';

export default function RequireCustomer({ children }: { children: React.ReactNode }) {
  useCustomerAuthSlice();
  const token = useAppSelector((s) => s.customerAuth?.token);
  const location = useLocation();

  if (!token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
